import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getSiteContent } from '../utils/siteContent';

/**
 * About Component
 * Renders the "About Us" page, providing information about the trust.
 */
const About = () => {
  const [siteContent, setSiteContent] = useState(() => getSiteContent());

  useEffect(() => {
    const handleContentUpdate = () => setSiteContent(getSiteContent());
    window.addEventListener('site-content-updated', handleContentUpdate);
    return () => window.removeEventListener('site-content-updated', handleContentUpdate);
  }, []);

  return (
    <div className="content-page-container" style={styles.container}>
      {/* Page Title & Intro */}
      <h1 id="about-page-heading" style={styles.title}>About Us</h1>
      <div style={styles.content}>
        <p style={styles.introText}>
          {siteContent.about.introOne}
        </p>
        <p style={styles.introText}>
          {siteContent.about.introTwo}
        </p>
      </div>

      <div id="about-info-grid" style={styles.infoGrid}>
        <div style={styles.infoCard}>
          <h2 style={styles.cardTitle}>Our Goals</h2>
          <p>{siteContent.about.goals}</p>
        </div>

        <div style={styles.infoCard}>
          <h2 style={styles.cardTitle}>Our Achievements</h2>
          <p>{siteContent.about.achievements}</p>
        </div>

        <div style={styles.infoCard}>
          <h2 style={styles.cardTitle}>Our Purpose</h2>
          <p>{siteContent.about.purpose}</p>
        </div>

        <div style={styles.infoCard}>
          <h2 style={styles.cardTitle}>Our Motif for Clipstone</h2>
          <p>{siteContent.about.motif}</p>
        </div>
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <Link id="about-meet-trustees-button" to="/trustees" style={styles.meetButton}>
          Meet Our Trustees
        </Link>
      </div>
    </div>
  );
};

const styles = {
  container: {
    padding: '60px 20px',
    maxWidth: '800px',
    margin: '0 auto',
    fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif'
  },
  title: {
    fontSize: '36px',
    color: '#1f2937',
    marginBottom: '24px',
    textAlign: 'center'
  },
  content: {
    fontSize: '18px',
    lineHeight: '1.6',
    color: '#4b5563',
    textAlign: 'center',
  },
  introText: {
    marginBottom: '12px',
  },
  infoGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '24px',
    marginTop: '32px',
  },
  infoCard: {
    backgroundColor: '#ffffff',
    border: '1px solid #e5e7eb',
    borderRadius: '16px',
    padding: '24px',
    boxShadow: '0 10px 24px rgba(0, 0, 0, 0.06)',
    textAlign: 'center',
  },
  cardTitle: {
    fontSize: '20px',
    color: '#1f2937',
    marginBottom: '10px',
  },
  staffSection: {
    marginTop: '40px',
  },
  staffTitle: {
    fontSize: '28px',
    color: '#1f2937',
    marginBottom: '24px',
    textAlign: 'center'
  },
  staffGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: '20px',
  },
  staffCard: {
    position: 'relative',
    background: '#ffffff',
    border: '1px solid #d1d5db',
    borderRadius: '12px',
    boxShadow: '0 8px 20px rgba(0, 0, 0, 0.05)',
    overflow: 'hidden',
  },
  imagePlaceholder: {
    background: '#e5e7eb',
    color: '#6b7280',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '180px',
    fontSize: '16px',
    fontWeight: '600',
  },
  staffInfo: {
    padding: '18px',
  },
  hoverOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: 'rgba(255, 255, 255, 0.96)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
    padding: '16px',
    boxSizing: 'border-box',
  },
  hoverImageBox: {
    width: '120px',
    minHeight: '120px',
    background: '#e5e7eb',
    border: '2px dashed #9ca3af',
    borderRadius: '12px',
  },
  hoverTextPlaceholder: {
    flex: 1,
    minHeight: '120px',
    background: '#f3f4f6',
    border: '2px dashed #9ca3af',
    borderRadius: '12px',
  },
  staffName: {
    fontSize: '20px',
    margin: '0 0 8px',
    color: '#111827',
  },
  staffText: {
    margin: '6px 0',
    color: '#4b5563',
    lineHeight: '1.5',
  },
  emailLink: {
    color: '#2563eb',
    textDecoration: 'none',
  },
  cardLink: {
    display: 'block',
    color: 'inherit',
    textDecoration: 'none',
  },
  meetButton: {
    display: 'inline-block',
    padding: '12px 24px',
    backgroundColor: '#1e3f32',
    color: '#ffffff',
    textDecoration: 'none',
    borderRadius: '8px',
    fontSize: '18px',
    fontWeight: '600',
    transition: 'background-color 0.2s',
  }
};

export default About;
